import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Typography} from "@material-ui/core";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";


const Theme = (borderRadius = '0 0 0 0') => createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: borderRadius,
            },
            input: {
                padding: '10px 14px',
            }
        },
        MuiInputLabel: {
            formControl: {
                top: '-12px',
                left: '10px'
            }
        },
        MuiDialogActions: {
            root: {
                justifyContent: 'center'
            }
        },
        MuiButton: {
            root: {
                borderRadius: borderRadius,
            },
            containedPrimary: {
                color: '#fff'
            },
            contained: {
                color: '#7a865d'
            }
        }
    },
    palette: {
        primary: {
            main: '#95c61c'
        },


    },
});

class ChangeWhitelistPopup extends React.Component {
    constructor(props) {
        super(props);

        this.handleClose = () => {
            this.props.onClose();
        };

        this.handleChange = (text) => {
            this.props.onChange(text);
        };

        this.handleSuccess = () => {
            this.props.onSuccess();
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.open !== this.props.open) {
            this.forceUpdate();
        }
    }

    render() {


        return (
            <div>
                <Dialog fullWidth open={this.props.open} onClose={this.handleClose} aria-labelledby="form-dialog-title"
                        style={{textAlign: "center"}}>
                    <DialogTitle style={{backgroundColor: '#f9f9f9'}} id="form-dialog-title"><b>Добавьте ID мужчин</b></DialogTitle>
                    <ThemeProvider theme={Theme('34px' || '0 0 0 0')}>
                        <DialogContent style={{textAlign: "center", marginBottom: '30px', }}>
                            <Typography>
                                Список ID
                            </Typography>
                            <TextField
                                style={{width: '80%'}}
                                multiline={true}
                                rows={8}
                                value={this.props.value}
                                onChange={e => this.props.onChange(e.target.value)}
                            />

                        </DialogContent>
                        <DialogActions style={{marginBottom: '20px'}}>
                            <Button variant={'contained'} onClick={this.handleClose} color="default">
                                Отмена
                            </Button>
                            <Button variant={'contained'} onClick={() => this.handleChange('')} color="secondary">
                                Сброс
                            </Button>
                            <Button variant={'contained'} onClick={() => {
                                this.handleSuccess();
                            }} color="primary">
                                Сохранить
                            </Button>
                        </DialogActions>
                    </ThemeProvider>
                </Dialog>
            </div>
        );
    }
}

export default ChangeWhitelistPopup